import React, { ReactNode } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';
import { VariantProps, cva } from 'class-variance-authority';
import { FaCheckCircle } from 'react-icons/fa';
import { IoCloseCircle } from 'react-icons/io5';
import MergeClassNames from '../../../utils/MergeClassNames';

interface INotificationProps extends VariantProps<typeof notificationVariants> {
  className?: string;
  handleClose?: () => void;
  children?: ReactNode;
  closable?: boolean;
  icon?: ReactNode;
}

export default function Notification({
  type,
  className,
  handleClose,
  children,
  closable = true,
  icon,
}: INotificationProps) {
  // `icon={null}` opts out of an icon entirely (and its layout gap);
  // omitting the prop keeps the existing type-based default icon.
  const resolvedIcon =
    icon !== undefined ? (
      icon
    ) : type === 'success' ? (
      <FaCheckCircle />
    ) : (
      <RiErrorWarningLine className="text-xl text-gray-dark" />
    );

  return (
    <>
      <div
        className={MergeClassNames(notificationVariants({ type, className }))}
      >
        <div className="flex items-start justify-between gap-2 p-2">
          {resolvedIcon && <div>{resolvedIcon}</div>}
          <div className="-mt-tiny flex-1 text-base">{children}</div>
          {closable && (
            <div>
              <IoCloseCircle
                onClick={handleClose}
                className={MergeClassNames(
                  'mt-tiny cursor-pointer text-xl',
                  type === 'success' || type === 'primary'
                    ? 'text-white'
                    : 'text-gray-dark'
                )}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const notificationVariants = cva('rounded-md', {
  variants: {
    type: {
      primary: 'bg-primary text-white',
      secondary: 'bg-secondary',
      success: 'bg-success text-white',
      danger: 'bg-danger-light text-black',
      warning: 'bg-yellow-500 text-white',
      info: 'bg-information text-black',
    },
  },
  defaultVariants: {
    type: 'primary',
  },
});
